import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';

function ConfirmReloadPopup({ 
    radioButtonSelection, 
    searchTextSelection, 
    titleText,
    closePopup, 
    HandleRadioButtonConfirmation,
    HandleSearchTextConfirmation,
    radioButtonValue,
    SearchTextType,
    SearchTextValue
}) {
    
    const handleRadioButtonSelection = () => {
        HandleRadioButtonConfirmation(radioButtonValue);
    };

    const handleSearchTextSelection = () => {
        const fieldValue = [SearchTextType, SearchTextValue];
        HandleSearchTextConfirmation(fieldValue);
    };

    // Don't render anything if no selection type is active
    if (!radioButtonSelection && !searchTextSelection) {
        return null;
    }

    return (
        <Dialog open={true} onOpenChange={(open) => !open && closePopup()}>
            <DialogContent className="sm:max-w-md">
                <DialogHeader>
                    <DialogTitle>
                        {radioButtonSelection ? 'Change Transaction Type' : 'Change PCN'}
                    </DialogTitle>
                </DialogHeader>
                
                <div className="py-4">
                    <p className="text-sm text-muted-foreground">
                        {radioButtonSelection 
                            ? titleText
                            : 'Adding this PCN is only available for Total Transactions. Your current Transaction Type selection will be updated to Total. Do you wish to continue?'
                        }
                    </p>
                </div>
                
                <DialogFooter className="gap-2 sm:gap-0">
                    <Button onClick={radioButtonSelection ? handleRadioButtonSelection : handleSearchTextSelection}>
                        Yes
                    </Button>
                    <Button variant="secondary" onClick={closePopup}>
                        No
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}

export default ConfirmReloadPopup;